import React from 'react'

const MicrosoftOffice = () => (
  <svg id="Capa_1" xmlns="http://www.w3.org/2000/svg" height="60px" viewBox="0 0 512 512">
    <polygon points="320,0 32,112 32,416 128,384 128,128 320,96 320,449.408 32,416 320,512 480,464 480,48" />
  </svg>
)

export default MicrosoftOffice
